import { Button } from "@/components/ui/button";
import { Plane, GraduationCap, Stethoscope } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { COPY } from "@/content/copy";

const verticals = [
  {
    icon: Plane,
    title: "Travel",
    label: "Travel",
    description: COPY.sublineByVertical.travel,
    bgClass: "bg-card",
    iconColor: "text-primary",
    primary: true,
  },
  {
    icon: GraduationCap,
    title: "Education",
    label: "Education",
    description: COPY.sublineByVertical.education,
    bgClass: "bg-card",
    iconColor: "text-primary",
    primary: false,
  },
  {
    icon: Stethoscope,
    title: "Healthcare",
    label: "Healthcare",
    description: COPY.sublineByVertical.healthcare,
    bgClass: "bg-card",
    iconColor: "text-primary",
    primary: false,
  },
];

const VerticalCardsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-4">
            Built for Life's Big Moments
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto leading-relaxed">
            Whatever matters most to you, Flexaura makes it affordable with flexible monthly payments from AED 2,000 to AED 200,000+
          </p>
          <p className="text-sm text-muted-foreground font-body mt-3">
            Eligibility and limits are determined by our partners.
          </p>
        </div>

        {/* CARDS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {verticals.map((vertical, index) => (
            <div
              key={index}
              className={`
                relative flex flex-col rounded-2xl border border-border 
                overflow-hidden transition-shadow duration-300
                hover:shadow-lg hover:shadow-primary/5
                ${vertical.bgClass}
              `}
            >
              {/* Card Content */}
              <div className="p-8 flex flex-col flex-grow">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-primary/10 border border-border flex items-center justify-center mb-6">
                  <vertical.icon
                    className={`w-7 h-7 ${vertical.iconColor}`}
                    strokeWidth={1.5}
                  />
                </div>

                {/* Title */}
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  {vertical.label}
                </h3>

                {/* Description */}
                <p className="text-muted-foreground font-body text-[15px] leading-relaxed mb-8 flex-grow">
                  {vertical.description}
                </p>

                {/* CTA Button */}
                {vertical.primary ? (
                  <Button
                    size="sm"
                    className="w-full font-medium"
                    onClick={() => navigate(`/${vertical.title.toLowerCase()}`)}
                  >
                    Get Early Access
                  </Button>
                ) : (
                  <Button
                    variant="outline"
                    size="sm"
                    className="w-full border-primary/20 text-foreground hover:bg-primary/5 hover:border-primary/30 font-medium"
                    onClick={() => navigate(`/${vertical.title.toLowerCase()}`)}
                  >
                    Get Early Access
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerticalCardsSection;
